import { useRef, useEffect, useState } from "react";
import { useInView } from "framer-motion";

export default function CounterAnimation({ end, suffix = "", duration = 2000 }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!isInView) return;
    let start = 0;
    const step = end / (duration / 16);
    const timer = setInterval(() => {
      start += step;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);
    return () => clearInterval(timer);
  }, [isInView, end, duration]);

  return (
    <span ref={ref} className="font-heading text-[#C8A951] text-4xl sm:text-5xl lg:text-6xl">
      {count}{suffix}
    </span>
  );
}
